// extracted by mini-css-extract-plugin
export default {"root":"ZCMeH","small":"_2YC3G","normal":"_3K5hq"};